<div *ngIf="data?.status === 'PURCHASED'" class="h-100" [ngStyle]="{'width': label === undefined ? '100px': ''}">

  <div ngbDropdown #dd="ngbDropdown" container="body" class="d-inline-block w-100 h-100"
    (click)="$event.stopPropagation()">

    <button type="button" class="btn btn-sm label-btn w-100 h-100" [ngClass]="getLabelClass(label)"
      [ngStyle]="{'padding': !table ? '12px' : '5px'}" id="dropdownLabel-{{ data.id }}" ngbDropdownToggle
      [disabled]="!canEdit">
      {{ getLabelDisplay(label) }}
    </button>

    <div ngbDropdownMenu [attr.aria-labelledby]="'dropdownLabel-' + data.id"
      [@menuAnimation]="(dd?.isOpen()) ? 'open' : 'closed'">
      <button *ngFor="let option of otherLabels" class="dropdown-item" [ngClass]="getOptionClass(option)"
        (click)="updateLabel(option, $event)">
        {{ getLabelDisplay(option) }}
      </button>
    </div>
  </div>
</div>